// Module
var code = `<div class="process-spacing">
    <div class="row">
        <div class="col-md-4">
            <div class="card">
                <div class="card-header">
                    <h5>Upload & Process</h5>
                </div>
                <div class="card-body">
                    <!-- Upload Area -->
                    <div class="upload-area" id="uploadArea">
                        <input type="file" id="fileInput" accept=".txt,.ds,.ds.txt" style="display:none" />
                        <div class="upload-prompt">
                            <i class="upload-icon">📁</i>
                            <p>Drag & drop Avid DS file here</p>
                            <small class="text-muted">Supported: .ds, .ds.txt</small>
                        </div>
                    </div>

                    <!-- Actions Panel -->
                    <div class="actions-panel" id="actionsPanel" style="display:none">
                        <div class="mb-3">
                            <label class="form-label">Current File</label>
                            <div class="alert alert-secondary" id="currentFile"></div>
                        </div>

                        <p class="text-muted small">
                            This tool automatically adjusts timing and spacing between subtitle entries for optimal readability.
                        </p>

                        <!-- Action Buttons -->
                        <div class="actions">
                            <button type="button" id="validateBtn" class="btn btn-outline-primary w-100 mb-2">
                                <span class="btn-text">Validate</span>
                                <span class="spinner-border spinner-border-sm d-none" role="status"></span>
                            </button>
                            <button type="button" id="spacingBtn" class="btn btn-success w-100 mb-2">
                                <span class="btn-text">Adjust Spacing</span>
                                <span class="spinner-border spinner-border-sm d-none" role="status"></span>
                            </button>
                            <button type="button" id="downloadBtn" class="btn btn-primary w-100" style="display:none">
                                Download Result
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-8">
            <!-- Validation Messages -->
            <div id="messagesContainer" style="display:none"></div>

            <!-- Editor -->
            <div class="card" id="editorCard" style="display:none">
                <div class="card-header">
                    <h5>Document Editor</h5>
                </div>
                <div class="card-body" style="height: 600px">
                    <doc-editor id="docEditor"></doc-editor>
                </div>
            </div>

            <!-- Placeholder -->
            <div class="card" id="placeholderCard">
                <div class="card-body text-center text-muted">
                    <p class="lead">Upload an Avid DS file to adjust spacing</p>
                </div>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;